module.exports = __webpack_public_path__ + "img/Othmar Stähelism.cca3d818.jpg";